export default "__VITE_ASSET__5cb700df__"